import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Priorities from '../components/Priorities';
import Experience from '../components/Experience';

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Experience />
      <Priorities />
    </div>
  );
};

export default Home;